import { render, staticRenderFns } from "./CollectionRepaymentIntentionPerformance.vue?vue&type=template&id=053ece60&scoped=true&"
import script from "./CollectionRepaymentIntentionPerformance.vue?vue&type=script&lang=js&"
export * from "./CollectionRepaymentIntentionPerformance.vue?vue&type=script&lang=js&"
import style0 from "./CollectionRepaymentIntentionPerformance.vue?vue&type=style&index=0&id=053ece60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053ece60",
  null
  
)

export default component.exports